<template>
    <div class="panel panel-info" v-if="usuario">
        <div class="panel-heading">
            <i class="fa fa-info-circle" aria-hidden="true"></i> {{title}}
        </div>
        <div class="panel-body" >

            <div class="form-group">
                <div class="col-sm-12">
                    <br/>
                    <label for="senha" class="control-label">NOME:</label>
                    <input id="senha" type="text" v-model="usuario.nome" class="form-control" >
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12">
                    <br/>
                    <label for="email" class="control-label">EMAIL:</label>
                    <input id="email" type="text" v-model="usuario.email" class="form-control" >
                </div>
            </div>

            <div class="form-group" v-if="usuario.level !== 100">
                <div class="col-sm-4">
                    <br/>
                    <label for="email" class="control-label">NÍVEL:</label>
                    <select v-model="usuario.level" class="form-control" >
                        <option :value="1">ADMINISTRADOR</option>
                        <option :value="2">GESTOR</option>
                        <option :value="5">MONITOR</option>
                    </select>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { Usuario } from "../../class/usuario";
export default {
    props: {
        usuario: {
            type: Object,
            default: () => Usuario.create()
        },
        disabled: {
            default: false
        },
        title: {
            default: "DADOS DO USUÁRIO"
        }
    }
};
</script>
